// extracted by mini-css-extract-plugin
export var businessType = "CaseTestimonials-module--businessType--B2DEo";
export var comment = "CaseTestimonials-module--comment--3ZALL";
export var container = "CaseTestimonials-module--container--lPvRh";
export var firstGroup = "CaseTestimonials-module--first-group--dEWoF";
export var head = "CaseTestimonials-module--head--iL8Jp";
export var image = "CaseTestimonials-module--image--RpdTH";
export var last = "CaseTestimonials-module--last--+lMuX";
export var limitWidthOnLargeScreens = "CaseTestimonials-module--limitWidthOnLargeScreens--JcLiR";
export var mobileLast = "CaseTestimonials-module--mobileLast--WInlu";
export var name = "CaseTestimonials-module--name--7wCNV";
export var overall = "CaseTestimonials-module--overall--9sGRQ";
export var secondGroup = "CaseTestimonials-module--second-group--6kL+e";
export var testimonials = "CaseTestimonials-module--testimonials--XmHn3";
export var title = "CaseTestimonials-module--title--4a8nB";
export var wrapper = "CaseTestimonials-module--wrapper--IrBU3";